/**
 * Constants for the Model Results page
 */

/** Maximum number of test images to fetch and display for model comparison */
export const MODEL_COMPARISON_IMAGE_LIMIT = 10;
